import React, { useEffect, useState } from "react";
import { Trophy, Lock } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Spinner } from "@/components/Bits";
import { Progress } from "@/components/ui/progress";

export default function Achievements() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/achievements").then((r) => setData(r.data)); }, []);
  if (!data) return <Spinner />;
  const pct = data.xp_to_next ? Math.round((data.xp_into_level / data.xp_to_next) * 100) : 0;

  return (
    <div className="p-5 lg:p-8 max-w-5xl mx-auto">
      <PageHeader title="Achievements" icon={Trophy} subtitle={`${data.earned_count} of ${data.total} unlocked`} />

      <div className="rounded-2xl border border-[hsl(var(--primary))]/30 bg-gradient-to-br from-[#1f6feb]/10 to-transparent p-6 mb-6" data-testid="xp-card">
        <div className="flex items-end justify-between mb-2">
          <div>
            <div className="text-xs uppercase tracking-wide text-[hsl(var(--muted-foreground))]">GameView XP</div>
            <div className="font-display font-extrabold text-2xl">Level {data.level}</div>
          </div>
          <div className="text-sm text-[hsl(var(--muted-foreground))] tabular-nums">{data.xp.toLocaleString()} XP total</div>
        </div>
        <Progress value={pct} className="h-3" data-testid="xp-progress" />
        <div className="text-xs text-[hsl(var(--muted-foreground))] mt-2 text-right tabular-nums">{data.xp_into_level} / {data.xp_to_next} XP to level {data.level + 1}</div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {data.catalog.map((a, i) => (
          <div key={a.key} data-testid={`achievement-${a.key}`}
            className={`relative rounded-2xl border p-5 text-center animate-rise delay-${(i % 5) + 1} ${a.earned ? "border-[hsl(var(--primary))]/40 bg-[hsl(var(--card))]" : "border-[hsl(var(--border))] bg-[hsl(var(--card))]/40"}`}>
            <span className={`absolute top-2 right-2 text-[10px] font-bold px-1.5 py-0.5 rounded-full ${a.earned ? "bg-[hsl(var(--primary))]/15 text-[hsl(var(--primary))]" : "bg-[hsl(var(--muted))]/40 text-[hsl(var(--muted-foreground))]"}`}>+{a.xp} XP</span>
            <div className={`text-4xl mb-2 ${a.earned ? "" : "opacity-50"}`}>{a.earned ? a.icon : <Lock className="w-8 h-8 mx-auto text-[hsl(var(--muted-foreground))]" />}</div>
            <div className="font-bold text-sm">{a.title}</div>
            <div className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">{a.desc}</div>
            {a.stat && !a.earned && (
              <div className="mt-3">
                <Progress value={a.progress * 100} className="h-1.5" />
                <div className="text-[10px] text-[hsl(var(--muted-foreground))] mt-1 tabular-nums">{a.have} / {a.need}</div>
              </div>
            )}
            {a.earned && <div className="mt-2 text-[11px] font-semibold text-emerald-500">Unlocked ✓</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
